import assetPath from '/app/packages/lebenslauf/articles/src/assets/flashpop.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')